class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    this.hoverCloseTimer = null;
    this.addEventListener('mouseenter', this.onHoverOpen.bind(this));
    this.addEventListener('mouseleave', this.onHoverClose.bind(this));
    if (this.content) {
      this.content.addEventListener('mouseenter', this.cancelHoverClose.bind(this));
      this.content.addEventListener('mouseleave', this.onHoverClose.bind(this));
    }

    // A nested list (Education > Settings) opens on hover too, as its parent does (2026-10-17).
    this.nestedDetails = this.content ? this.content.querySelectorAll('details') : [];
    this.nestedDetails.forEach((details) => {
      let closeTimer = null;
      details.addEventListener('mouseenter', () => {
        if (window.matchMedia('(hover: none)').matches) return;
        clearTimeout(closeTimer);
        this.setNestedOpen(details, true);
      });
      details.addEventListener('mouseleave', () => {
        if (window.matchMedia('(hover: none)').matches) return;
        clearTimeout(closeTimer);
        closeTimer = setTimeout(() => this.setNestedOpen(details, false), 150);
      });
    });
  }

  setNestedOpen(details, open) {
    details.toggleAttribute('open', open);
    details.querySelector('summary').setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  // Closing the dropdown closes its nested lists too, so it reopens collapsed.
  close() {
    super.close();
    this.nestedDetails.forEach((details) => this.setNestedOpen(details, false));
  }

  cancelHoverClose() {
    if (this.hoverCloseTimer) {
      clearTimeout(this.hoverCloseTimer);
      this.hoverCloseTimer = null;
    }
  }

  onHoverOpen() {
    if (window.matchMedia('(hover: none)').matches) return;
    this.cancelHoverClose();
    document.querySelectorAll('header-menu').forEach((menu) => {
      if (menu !== this) menu.close();
    });
    if (!this.mainDetailsToggle.hasAttribute('open')) {
      this.mainDetailsToggle.setAttribute('open', '');
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', 'true');
    }
  }

  onHoverClose(event) {
    if (window.matchMedia('(hover: none)').matches) return;
    var related = event && event.relatedTarget;
    if (related && (this.contains(related) || (this.content && this.content.contains(related)))) {
      return;
    }
    this.cancelHoverClose();
    this.hoverCloseTimer = setTimeout(() => {
      this.close();
      this.hoverCloseTimer = null;
    }, 150);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
